import { useListContext } from 'react-admin'
import InvoicePaidButton from './actionButtons/InvoicePaidButton'
import InvoiceMarkInvoiceAsPendingButton from './actionButtons/InvoiceMarkAsPendingButton'
import InvoiceMarkInvoiceAsPastDueButton from './actionButtons/InvoiceMarkAsPastDueButton'
import CreateInvoiceReminderButton from './actionButtons/CreateInvoiceReminderButton'
import InvoiceBookBulkButton from './actionButtons/InvoiceBookBulkButton'

const InvoiceBulkActionButtons = ({userId}: {userId: string}) => {

  const { selectedIds } = useListContext()

  return (
    <>
      <InvoicePaidButton recordIds={selectedIds} userId={userId} />
      <InvoiceMarkInvoiceAsPendingButton recordIds={selectedIds} userId={userId} />
      <InvoiceMarkInvoiceAsPastDueButton recordIds={selectedIds} userId={userId} />
      <CreateInvoiceReminderButton recordIds={selectedIds} />
      <InvoiceBookBulkButton recordIds={selectedIds} />
    </>
  )
}

export default InvoiceBulkActionButtons